<template>
  <v-card class="py-4" max-width="900">
    <v-card-title class="d-flex">
      <v-spacer />
      <div class="headline text-center text--lighten-2 font-weight-medium">
        Air Service Quote
      </div>
      <v-spacer />
    </v-card-title>
    <v-divider class="mb-4" v-if="$vuetify.breakpoint.smAndDown" />
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col :cols="12" :xs="12" :sm="6" :md="6">
            <div class="black--text title mb-4">Contact Info</div>
            <v-row no-gutters>
              <v-col class="pr-1">
                <div class="black--text caption font-weight-medium">
                  FIRST NAME
                </div>
                <v-text-field
                  v-model="firstName"
                  dense
                  outlined
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col class="pl-1">
                <div class="black--text caption font-weight-medium">
                  LAST NAME
                </div>
                <v-text-field
                  v-model="lastName"
                  dense
                  outlined
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  COMPANY NAME
                </div>
                <v-text-field
                  v-model="form.companyName"
                  :rules="[rules.required]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  EMAIL
                </div>
                <v-text-field
                  v-model="form.email"
                  :rules="[rules.required, rules.email]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  PHONE NUMBER
                </div>
                <v-text-field
                  v-model="form.phoneNumber"
                  :rules="[rules.required]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col :cols="12" :xs="12" :sm="6" :md="6">
            <div class="black--text title mb-4">Routing Info</div>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  ORIGIN COUNTRY
                </div>
                <v-text-field
                  v-model="form.originCountry"
                  :rules="[rules.required]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  ADDRESS OF ORIGIN
                </div>
                <v-text-field
                  v-model="form.addressOfOrigin"
                  :rules="[rules.required]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  DESTINATION COUNTRY
                </div>
                <v-text-field
                  v-model="form.destinationCountry"
                  :rules="[rules.required]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="black--text caption font-weight-medium">
                  ADDRESS OF DESTINATION
                </div>
                <v-text-field
                  v-model="form.addressOfDestination"
                  :rules="[rules.required]"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <div class="black--text title">Freight Info</div>
        <v-row>
          <v-col class="pb-0">
            <div class="black--text caption font-weight-medium">
              DESCRIPTION OF FREIGHT CONTENT
            </div>
            <v-textarea
              v-model="form.freight.freightDescription"
              :rules="[rules.required]"
              dense
              outlined
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            :cols="12"
            :xs="12"
            :sm="6"
            :md="6"
            style="max-width: 250px;"
            class="pb-0 pt-0"
          >
            <div class="black--text caption font-weight-medium">
              NUMBER OF BOXES / CRATES
            </div>
            <v-text-field
              v-model="form.freight.numBoxesCrates"
              :rules="[rules.required]"
              type="number"
              dense
              outlined
            />
          </v-col>
          <v-col style="max-width: 250px;" class="pb-0 pt-0">
            <div class="black--text caption font-weight-medium">
              GROSS WEIGHT
            </div>
            <v-text-field
              v-model="form.freight.grossWeight"
              :rules="[rules.required]"
              min="0"
              type="number"
              hint="**No Parcel Size Shipments**"
              persistent-hint
              dense
              outlined
            >
              <template v-slot:append>
                <v-btn-toggle
                  style="margin-top: -2px;"
                  mandatory
                  dense
                  v-model="isImperial"
                >
                  <v-btn min-width="0" small>
                    lb
                  </v-btn>

                  <v-btn min-width="0" small>
                    kg
                  </v-btn>
                </v-btn-toggle>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-radio-group
          v-model="form.freight.isHazardous"
          :rules="[rules.required]"
        >
          <v-row no-gutters>
            <v-col class="d-flex">
              <div
                style="line-height: 2em;"
                class="black--text caption font-weight-medium mr-4"
              >
                ARE THE CONTENT'S CONSIDERED HAZARDOUS?
              </div>
              <v-radio
                hide-details
                color="black"
                label="Yes"
                value="Yes"
                class="mr-4 mb-0"
              ></v-radio>
              <v-radio
                hide-details
                color="black"
                label="No"
                value="No"
              ></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>

        <v-row>
          <v-col>
            <div class="black--text caption font-weight-medium text-uppercase">
              If multiple pcs, list pcs, weights, dimensions here
            </div>
            <v-textarea
              v-model="form.freight.additionalDescription"
              dense
              hide-details
              outlined
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="black--text caption font-weight-medium">
              SERVICE REQUIRED
            </div>
            <v-select
              v-model="form.freight.serviceRequired"
              style="max-width: 250px;"
              :rules="[rules.required]"
              single-line
              label="Select an option"
              :items="services"
              item-text="name"
              item-value="name"
              dense
              outlined
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="pr-10">
      <v-spacer />
      <v-btn
        class="px-10"
        :color="sent ? 'success' : 'primary'"
        :loading="isSending"
        rounded
        @click="send()"
      >
        <template v-if="sent">
          <v-icon>done</v-icon>
          Sent
        </template>
        <template v-else>
          Send
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'
const URL = 'https://vancouverglobalshipping.com/WebsiteFormEmailer'

export default {
  data() {
    return {
      sent: false,
      isSending: false,
      dialog: false,
      isImperial: 0,
      firstName: '',
      lastName: '',
      form: {
        service: 'Air Service Quote',
        fullName: '',
        companyName: '',
        email: '',
        phoneNumber: '',
        originCountry: '',
        addressOfOrigin: '',
        destinationCountry: '',
        addressOfDestination: '',
        freight: {
          serviceRequired: '',
          freightDescription: '',
          isHazardous: null,
          numBoxesCrates: '',
          grossWeight: '',
          additionalDescription: '',
        },
      },
      services: [
        { name: 'Airport to Airport' },
        { name: 'Airport to Door' },
        { name: 'Door to Airport' },
        { name: 'Door to Door - all inc.' },
      ],
      rules: {
        required: (v) => !!v || 'Required',
        oneOrMore: (v) => v && v.length > 0,
        email: (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      },
    }
  },
  methods: {
    close() {
      this.dialog = false
    },
    async send() {
      if (!this.$refs.form.validate()) {
        console.log('Form invalid')
        return
      }

      this.isSending = true

      try {
        let form = JSON.parse(JSON.stringify(this.form))
        form.freight.grossWeight += this.isImperial === 0 ? 'lb' : 'kg'
        form.fullName = `${ this.firstName } ${ this.lastName }`

        let response = await axios.post(URL, form)

        if (!response.data.err) {
          this.sent = true
          this.$emit('submitted')
          this.close()
          console.log(response)
        } else {
          console.error(response.data.err)
        }
      } catch (err) {
        console.error(err.toString());
      }

      this.isSending = false
    },

  },
}
</script>